import { langServerClient } from '@/shared/api/langserver';
import { createDemoParseResponse, shouldUseDemoLangServer } from '@/shared/api/langserver/demo';

import type { ModuleTarget } from '@/entities/langserver/api/types';

import type { ParseRequest, ParseResponse } from './types';

export async function fetchParse(target: ModuleTarget = 'run', request: ParseRequest): Promise<ParseResponse> {
  if (shouldUseDemoLangServer(target)) {
    return createDemoParseResponse(request);
  }

  const response = await langServerClient.post<ParseResponse>(`/${target}/api/v1/analysis/parse`, {
    clientId: request.clientId,
    code: request.code,
    files: request.files,
  });

  return response.data;
}
